export default __webpack_public_path__ + "static/b_radler_02-f6781054f542ab62b113263c3d8f0af1.png";